import React from "react";
import {HEALTH_STATUS} from "src/common/constants/constants";
import {getHighestSevOpenEvent} from "src/common/utils/eventsUtil";
import {IEvent} from "src/context/models/Event";

type Props = {
    events: IEvent[] | undefined,
    sectionName: string,
    operationId: string | null
};
export const HealthIndicator: React.FC<Props> = ({
                                                     events,
                                                     sectionName,
                                                     operationId
                                                 }) => {

    const determineHealth = (events: IEvent[] | undefined, section: string, operationId: string | null) => {
        const openSectionEvent: IEvent | undefined = getHighestSevOpenEvent(events, operationId);
        if (openSectionEvent) {
            return HEALTH_STATUS[openSectionEvent.eventSeverity as keyof typeof HEALTH_STATUS];
        } else {
            return HEALTH_STATUS.GREEN;
        }
    };

    return (<span slot="badge">{determineHealth(events, sectionName, operationId)}</span>);
}